import { getVerificationParam } from "/app/src/routes/{-$locale}/offers/$id/reviews.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id/reviews.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import "@mdxeditor/editor/style.css";
import { dehydrate } from "@tanstack/react-query";
import { httpClient } from "@/lib/http-client";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { generateOfferMeta } from "@/lib/generate-offer-meta";
import { getQueryClient } from "@/lib/client";
import { offerOnlyQueryOptions } from "@/queries/offer-gql";
import i18n from "@/lib/i18n";
type ReviewSummary = {
  overallScore: number;
  recommendedPercentage: number;
  notRecommendedPercentage: number;
  totalReviews: number;
};
type ReviewsFilter = "all" | "verified" | "not-verified";
export const Route = createFileRoute("/{-$locale}/offers/$id/reviews")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      id
    } = params;
    const {
      queryClient,
      epicToken,
      locale,
      session
    } = context;
    const user = epicToken;
    const offer = await queryClient.ensureQueryData(offerOnlyQueryOptions(id, locale));
    await Promise.allSettled([queryClient.prefetchQuery({
      queryKey: ["reviews", {
        id: params.id,
        page: 1,
        verified: getVerificationParam("all")
      }],
      queryFn: () => httpClient.get<{
        elements: Array<SingleReview>;
        page: number;
        total: number;
        limit: number;
      }>(`/offers/${params.id}/reviews`, {
        params: {
          page: 1,
          verified: getVerificationParam("all")
        }
      }).catch(() => null)
    }), queryClient.prefetchQuery({
      queryKey: ["reviews-summary", {
        id: params.id,
        verified: getVerificationParam("all")
      }],
      queryFn: () => httpClient.get<ReviewSummary>(`/offers/${params.id}/reviews-summary`, {
        params: {
          verified: getVerificationParam("all")
        }
      }).catch(() => null)
    }), queryClient.prefetchQuery({
      queryKey: ["ratings", {
        id: params.id
      }],
      queryFn: () => httpClient.get<RatingsType>(`/offers/${params.id}/ratings`).catch(() => null)
    })]);
    return {
      id,
      dehydratedState: dehydrate(queryClient),
      userId: session?.user?.email.split("@")[0] ?? user?.account_id,
      offer,
      locale
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData.dehydratedState, [...offerOnlyQueryOptions(params.id, ctx.loaderData.locale).queryKey]);
    if (!offer) return {
      meta: [{
        title: i18n.t("offerDetail.common.offerNotFound"),
        description: i18n.t("offerDetail.common.offerNotFound")
      }]
    };
    return {
      meta: generateOfferMeta(offer, "Reviews")
    };
  }
});